// extracted by mini-css-extract-plugin
export default {"container":"SiteInfoAdmin_container__QSXAW","section":"SiteInfoAdmin_section__la6es"};